import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-ivory px-3 py-4 sm:px-6" data-id="element-41" data-mp="1hd1nvzbcra01">
      <div className="mx-auto max-w-2xl" data-id="element-42" data-mp="1hdukw8kiel4z">
        <h2 className="text-center font-heading text-[1.15rem] font-bold uppercase text-navy sm:text-[1.9rem]" data-id="element-43" data-mp="1ceqajelumhd2">
          Frequently asked questions
        </h2>
        <div className="mt-2 divide-y divide-navy/10 overflow-hidden rounded-md border border-navy/10 bg-white shadow-sm" data-id="element-44" data-mp="2a05wsfdkg8h3">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} data-id="element-45" data-mp="1v4zotmuwtzl4" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-2.5 px-2.5 py-2 text-left" data-id="element-46" data-mp="1v5rdseu04z2f">
                  <span className="font-body text-[0.8rem] font-bold leading-tight text-navy sm:text-[0.95rem]" data-id="element-47" data-mp="1ko004h7y6gwi">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-48" data-mp="1pkqnzqpzugsh" />
                </button>
                {isOpen ? <p className="px-2.5 pb-2 text-[0.8rem] leading-[1.35] text-muted sm:text-[0.95rem]" data-id="element-49" data-mp="16np6j6f96o7n">
                    {faq.a}
                  </p> : null}
              </div>;
        })}
        </div>
      </div>
    </section>;
}